import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getSettlementData, selectPricesIsLoading, selectSettlementData } from '../feature';

export const useGetSettlementData = () => {
  const data = useAppState(selectSettlementData);
  const isLoading = useAppState(selectPricesIsLoading);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getSettlementData());
  }, []);

  return useMemo(() => ({ data, isLoading }), [data, isLoading]);
};
